module.exports = __webpack_public_path__ + "img/rg_rojo-02.0a0a9ffe.png";